import { useTheme } from '@mui/material/styles';

export const Default = ({ color, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.white[30];

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="61" height="173" viewBox="0 0 61 173" fill="none">
            <path d="M50 13.5H60V49.5L0.5 172.5M44 0.5H50V26.5H44" stroke={finalColor} strokeOpacity="1" />
        </svg>
    );
};

export const Win01 = ({ color, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.buttonOrange;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="61" height="173" viewBox="0 0 61 173" fill="none">
            <path d="M43.9492 0.5H49.9492V13.5H59.9492V49.5L0.449219 172.5" stroke={finalColor} />
        </svg>
    );
};

export const Win02 = ({ color, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.buttonOrange;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="61" height="160" viewBox="0 0 61 160" fill="none">
            <path d="M43.9492 13.5H49.9492V0.5H59.9492V36.5L0.449219 159.5" stroke={finalColor} />
        </svg>
    );
};